import axios from "axios";
import {API} from "../constants";

export const getAllProducts = async () => {
    return axios.get(`${API.PRODUCTS}all/`)
}

export const getAllProductsService = async () => {
    return axios.get(`${API.PRODUCTS}services/`)
}